export default __webpack_public_path__ + "adaa93783f8ba9ecbfe5e213089e893c.json";